import 'angular';
MigrationController.$inject = ['$scope', 'View'];
angular.module('GorillaBoy.FileBrowser').controller('MigrationController', MigrationController);
function MigrationController($scope, View) {
    // SECTION: Layout code
    $scope.layout = {
        partialContent: './migrate-home-drive/content_partial.html',
        partialTitleBar: './migrate-home-drive/title_bar.html',
        view: View,
        //Master copy of whether left sidebar should be shown/hidden.
        showLeftSidebar: false,
        hasRightSidebar: false,
        showRightSidebar: false,
        showUploadPane: false
    };
    $scope.sidebar = {
        selectedIndex: 0,
        tabName: 'People',
        tabs: []
    };
}
